<template>
  <div class="richtext">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'KfRichText',
};
</script>

<style lang="postcss">
.richtext {

  p {
    line-height: theme('lineHeight.xl');
  }

  // margin bottom for rte elements
  p,
  ul,
  ol,
  .richtext-download-links,
  .richtext-external-links,
  .richtext-buttons-primary {
    @apply mb-7;
  }

  > :last-child {
    @apply mb-0;
  }

  // links & buttons
  .richtext-download-links,
  .richtext-external-links {
    @apply flex flex-col;

    a:not(:last-child) {
      @apply mb-2;
    }
  }

  .richtext-download-links a:not(:last-child),
  .richtext-external-links a:not(:last-child) {
    @apply mb-2;
  }

  .richtext-buttons-primary a:not(:last-child) {
    @apply mr-3 mb-2;
  }

  // lists
  ul,
  ol {
    @apply ml-5;

    li {
      @apply pl-6;
    }
  }

  ul {
    /* @apply list-none; */

    li:before {
      @apply w-6 -ml-6 text-primary-bravo font-normal inline-block;
      content: "\2022";
    }
  }

  ol {
    @apply list-decimal;
  }

}
</style>
